import { pxToRem } from "@/util";
import { Box, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
// import { AppColors } from "@/assets/colors";

export default function Header() {
  const { classes } = styles();

  return (
    <Box className={classes.container}>
      {/* Background Image */}
      <Box className={classes.imgCont}>
        <Image
          src="/images/consultation/book.png"
          alt="discover"
          objectFit="cover"
          fill
        />
      </Box>

      {/* Overlay */}
      <Box className={classes.overlay} />

      {/* Text Content */}
      <Box className={classes.detCont}>
        <Typography className={classes.head}>
          Get Expert Real Estate Guidance with AREL
        </Typography>
        <Typography className={classes.desc}>
          Schedule a free consultation to explore our premium real estate
          solutions, investment opportunities, and custom property developments
        </Typography>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: pxToRem(377),
    position: "relative",
    padding: theme.spacing(4),

    [theme.breakpoints.down("sm")]: {
      minHeight: pxToRem(420),
      padding: theme.spacing(2),
    },
  },
  imgCont: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 0,
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.25)",
    zIndex: 1,
  },

  detCont: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    width: "60%",
    alignItems: "center",
    textAlign: "center",

    [theme.breakpoints.down("md")]: {
      width: "80%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  head: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(60),
    color: "#FFFFFF",
    lineHeight: "120%",
    width: "80%",

    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(34),
      width: "100%",
    },
  },
  desc: {
    fontWeight: 400,
    fontSize: pxToRem(20),
    lineHeight: "160%",
    color: "#E4E4E4",
    width: "70%",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: pxToRem(16),
    },
  },
}));
